import axios from "axios";
import { tmsApi } from "../api";

export const createServiceCity = async (body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .post(tmsApi + "v1/entities/servicecity/create", body, config)
      .then((response) => {
        console.log("");
        console.log("Create service city API Response: ", response);
        console.log("");

        return response;
      });
  } catch (error) {
    console.log("");
    console.log("API Error: ", error);
    console.log("");

    return error;
  }
};

export const updateServiceCity = async (body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .put(tmsApi + "v1/entities/servicecity/update", body, config)
      .then((response) => {
        console.log("");
        console.log("Update service city API Response: ", response);
        console.log("");

        return response;
      });
  } catch (error) {
    console.log("");
    console.log("API Error: ", error);
    console.log("");

    return error;
  }
};

export const deleteServiceCity = async (id, isDeleted) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .delete(
        tmsApi + `v1/entities/servicecity/${id}?isDeleted=${isDeleted}`,
        config
      )
      .then((response) => {
        console.log("");
        console.log("Delete service city API Response: ", response);
        console.log("");

        return response;
      });
  } catch (error) {
    console.log("");
    console.log("API Error: ", error);
    console.log("");

    return error;
  }
};

export const getServiceCityTableData = async (obj, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(
        tmsApi + `v1/entities/servicecityall?page=${obj.page}&size=${obj.size}`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};
